/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>


      <AsideMenuItem
            to='/apps/connector-queue-management/connector-queue'
            title='Connector Queue'
       />
      <AsideMenuItem to="/apps/connection-management/connection" title="Connection" />
      <AsideMenuItem to="/apps/sources-management/sources" title="Sources" />
      <AsideMenuItem to="/apps/destinations-management/destinations" title="Destinations" />
      
      <AsideMenuItem
        to='/apps/orderhistory-management/order-detail/'
        title='Order Log'
      />

      <AsideMenuItem
        to='/apps/shopify-connect/shopify-user'
        title='Shopify Connect'
      />

       {/* Menu Product */}
      <AsideMenuItemWithSub
        to="/apps/product-management"
        title="Product Management"
      >
        <AsideMenuItem
          to="/apps/product-management/product-list"
          title="Product"
        />
        <AsideMenuItem
          to="/apps/product-management/product-sync-log"
          title="Product Sync Log"
        />
      </AsideMenuItemWithSub>
      {/* End Menu Product */}

      <AsideMenuItem
        to='/apps/user-management/users'
        title='User management'
      />


    </>
  )
}
